// Screen geometry for the timeline on /ielts/calculator.
//
// ⛔ No engine arithmetic here, the same rule as ieltsPlan.js. Every week and
// band comes from the row the server precomputed for the slider's position;
// these functions only turn those figures into positions on a drawing. Even
// where the path crosses the exam week comes from the server.

const TICK_STEPS = [1, 2, 4, 13, 26, 52]

/**
 * How many weeks the drawing spans: a little past whichever comes last, so the
 * final point never sits on the edge.
 */
export function weekExtent (examWeek, arrivalWeek) {
  return Math.max(examWeek, arrivalWeek ?? 0) * 1.08
}

export function weekScale (extent, { left, right }) {
  return (week) => left + (week / extent) * (right - left)
}

// Higher bands sit higher, so the reader's path climbs.
export function bandScale (fromBand, toBand, { top, bottom }) {
  return (band) => bottom - ((band - fromBand) / (toBand - fromBand)) * (bottom - top)
}

/**
 * Week labels on round steps. A phone-width drawing gets at most four, a wide
 * one at most eight, so labels never collide.
 */
export function weekTicks (extent, width) {
  const limit = width < 500 ? 4 : 8
  const step = TICK_STEPS.find((candidate) => Math.floor(extent / candidate) + 1 <= limit) ?? TICK_STEPS[TICK_STEPS.length - 1]
  const ticks = []

  for (let week = 0; week <= extent; week += step) ticks.push(week)
  return ticks
}

/**
 * The reader's path as [week, band] points, cut at the exam week. `before` is
 * what they cover by the exam; `after` is the part still to go.
 *
 * ⛔ Where the path crosses the exam line is the server's figure
 * (`bandAtExam.position`), not a second interpolation here: the dot has to sit
 * on the band the headline names.
 */
export function splitAtExam (startBand, milestones, examWeek, bandAtExam) {
  if (!Array.isArray(milestones) || milestones.length === 0) return { before: [], after: [], crossing: null }

  const points = [[0, startBand], ...milestones.map((milestone) => [milestone.week, milestone.band])]
  const index = points.findIndex(([week]) => week > examWeek)

  if (index === -1) return { before: points, after: [], crossing: null }

  const crossing = [examWeek, bandAtExam]

  return {
    before: [...points.slice(0, index), crossing],
    after: [crossing, ...points.slice(index)],
    crossing
  }
}
